
import { responsiveFontSizes, adaptV4Theme, createTheme as createMuiTheme } from '@mui/material'

export default function createTheme (options) {
  const theme = createMuiTheme(adaptV4Theme({
    palette: {
      mode: options?.darkTheme ? 'dark' : 'light'
    },
    overrides: {
      MuiListItemText: {
        primary: {
          fontSize: '12px'
        }
      },
      MuiToolbar: {
        root: {
          backgroundColor: '#303030'
        }
      }
    }
  }, {
    palette: {
      primary: {
        main: '#FBC337'
      }
    }
  }))

  return responsiveFontSizes(theme)
}
